import { lazy } from "react";
const AdvertiseAr = lazy(() => import("../Components/Advertise.js").then(mod => ({ default: () => <mod.default lang="ar" /> })));
const AdvertiseEn = lazy(() => import("../Components/Advertise.js").then(mod => ({ default: () => <mod.default lang="en" /> })));
const AdvertiseFr = lazy(() => import("../Components/Advertise.js").then(mod => ({ default: () => <mod.default lang="fr" /> })));
const AdvertiseId = lazy(() => import("../Components/Advertise.js").then(mod => ({ default: () => <mod.default lang="id" /> })));
export const mainRoutes = [
    { path: "/en/", component: lazy(() => import("../Components/LandingPageEN/LandingPage")), },
    { path: "/en/all-calculators", component: lazy(() => import("../Components/En/All-Calculators.js")), },
    { path: "/ar/about/", component: lazy(() => import("../Components/Ar/About")), },
    { path: "/ar/advertise/", component: AdvertiseAr, },
    { path: "/en/advertise/", component: AdvertiseEn, },
    { path: "/fr/advertise/", component: AdvertiseFr, },
    { path: "/id/advertise/", component: AdvertiseId, },
    { path: "/en/", component: lazy(() => import("../Components/LandingPageEN/LandingPage")), },
    { path: "/en/about/", component: lazy(() => import("../Components/En/About")), },
    { path: "/fr/about/", component: lazy(() => import("../Components/Fr/About")), },
    { path: "/id/about/", component: lazy(() => import("../Components/Id/About")), },

    { path: "/ar/privacy/", component: lazy(() => import("../Components/Ar/Policy")), },
    { path: "/ar/all-calculators/", component: lazy(() => import("../Components/Ar/All-Calculators")), },
    { path: "/id/privacy/", component: lazy(() => import("../Components/Ar/Policy")), },

    { path: "/fr/all-calculators/", component: lazy(() => import("../Components/Fr/All-Calculators")), },
    { path: "/fr/calculators/", component: lazy(() => import("../Components/Fr/MathCalculator/Calculators")), },

    // add indionesia routes here
    { path: "/id/", component: lazy(() => import("../Components/LandingPageId/LandingPage")), },
    { path: "/id/all-calculators", component: lazy(() => import("../Components/Id/All-Calculators.js")), },

];